module.exports = "/images/communication-action-plan.svg?f9f2387310f17b7708bf7baecc98a3d9";